import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container-app py-16 max-w-3xl">
        <h1 className="font-heading text-4xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-muted-foreground mb-8">Last updated: February 2026</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold">1. Information We Collect</h2>
            <p>We collect information you provide when creating an account, enrolling in courses, or contacting us. This includes:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Parent/guardian name, email, phone, and address</li>
              <li>Child name, date of birth, grade, school, and medical information</li>
              <li>Payment information (processed securely by Stripe)</li>
              <li>Course enrollment and attendance records</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide and manage course enrollments</li>
              <li>To communicate about courses, schedules, and updates</li>
              <li>To process payments</li>
              <li>To ensure the safety and well-being of participants</li>
              <li>To send promotional emails (with your consent)</li>
              <li>To improve our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold">3. Information Sharing</h2>
            <p>We do not sell your personal information. We may share information with:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Payment processors (Stripe) for transaction processing</li>
              <li>Email service providers (SendGrid) for communications</li>
              <li>Instructors and staff as needed for course delivery</li>
              <li>Law enforcement when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold">4. Children's Privacy</h2>
            <p>We are committed to protecting children's privacy. We collect children's information only from their parent/guardian. We do not knowingly collect information directly from children under 13.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">5. Data Security</h2>
            <p>We use industry-standard security measures to protect your information, including encrypted connections (HTTPS), secure password storage, and access controls.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">6. Email Communications</h2>
            <p>You may receive emails about course updates, enrollment confirmations, and promotional offers. You can unsubscribe from promotional emails at any time by clicking the unsubscribe link in any email or contacting us directly.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">7. Cookies</h2>
            <p>We use cookies and similar technologies to maintain your session, remember preferences, and analyze usage. You can control cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">8. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your account</li>
              <li>Opt out of promotional communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold">9. Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. We will notify you of significant changes via email or a notice on our website.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">10. Contact</h2>
            <p>For privacy-related questions, contact us at <a href="mailto:info@readysetstem.org" className="text-primary">info@readysetstem.org</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t text-center">
          <Link to="/" className="text-primary font-semibold">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
